/** Support working time, format 'h:mm' (MSK zone) */
const SUPPORT_START = '9:00';
const SUPPORT_END = '21:00';
const defaultSupport = {
    phone: '88007073902',
    supportStart: SUPPORT_START,
    supportEnd: SUPPORT_END,
    chatLink: 'https://sravni.onelink.me/cyn1/1edwjpag',
    channels: [],
};

export { defaultSupport };
//# sourceMappingURL=support.js.map
